var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-arealoading"},[_c('span',{staticClass:"zelan-arealoading__icon",domProps:{"innerHTML":_vm._s(_vm.loadingIcon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }